module.exports = __webpack_public_path__ + "static/condo_screen-clickup-2815742f183f18d6b2571b6abece5398.jpg";